<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>{{tituloCrud}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioFilial" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-8 col-md-9 col-sm-12 col-12">
                            <mat-label>Nome</mat-label>
                            <input matInput value="Nome" class="form-control" id="nome" required trim="blur" name="nome"
                                formControlName="nome" maxlength="60" upperCase>
                            <mat-error *ngIf="formularioFilial.controls.nome.hasError('required')">
                                O campo Nome é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioFilial.controls.nome.hasError('minlength')">
                                O campo Nome precisa conter mais do que 5 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-3 col-sm-12 col-12">
                            <mat-label>CNPJ</mat-label>
                            <input matInput value="CNPJ" class="form-control" id="cnpj" trim="blur" name="cnpj"
                                formControlName="cnpj" maxlength="18" trim="blur" mask="00.000.000/0000-00" required>
                            <mat-error *ngIf="formularioFilial.controls.cnpj.hasError('required')">
                                O campo CNPJ é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioFilial.controls.cnpj.hasError('cnpjError')">
                                O campo CNPJ está inválido.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                            <mat-label>Logradouro</mat-label>
                            <input matInput value="Logradouro" class="form-control" id="logradouro" trim="blur"
                                name="logradouro" formControlName="logradouro" maxlength="60" upperCase required>
                            <mat-error *ngIf="formularioFilial.controls.logradouro.hasError('required')">
                                O campo Logradouro é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioFilial.controls.logradouro.hasError('minlength')">
                                O campo Logradouro precisa conter mais do que 5 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Número</mat-label>
                            <input matInput value="Número" class="form-control" id="numero" name="numero"
                                formControlName="numero" maxlength="10" trim="blur" upperCase required>
                            <mat-error *ngIf="formularioFilial.controls.numero.hasError('required')">
                                O campo Número é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Bairro</mat-label>
                            <input matInput value="Bairro" class="form-control" id="bairro" trim="blur" name="bairro"
                                formControlName="bairro" maxlength="40" upperCase required>
                            <mat-error *ngIf="formularioFilial.controls.bairro.hasError('required')">
                                O campo Bairro é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioFilial.controls.bairro.hasError('minlength')">
                                O campo Bairro precisa conter mais do que 4 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Cidade</mat-label>
                            <input matInput value="Cidade" class="form-control" id="cidade" name="cidade"
                                formControlName="cidade" maxlength="40" trim="blur" upperCase required>
                            <mat-error *ngIf="formularioFilial.controls.cidade.hasError('required')">
                                O campo Cidade é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioFilial.controls.cidade.hasError('minlength')">
                                O campo Cidade precisa conter mais do que 5 caracteres.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-5 col-md-7 col-sm-7 col-12">
                            <mat-label>Complemento</mat-label>
                            <input matInput value="Complemento" class="form-control" id="complemento" trim="blur"
                                name="complemento" formControlName="complemento" maxlength="60" upperCase>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-3 col-md-5 col-sm-5 col-12">
                            <mat-label>UF</mat-label>
                            <mat-select value="UF" formControlName="estado" name="uf" id="uf">
                                <mat-option *ngFor="let uf of listaUFs" [value]="uf.sigla">
                                    {{uf.nome}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioFilial.controls.estado.hasError('required')">
                                O campo UF é obrigatório.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-2 col-md-6 col-sm-6 col-6">
                            <mat-label>CEP</mat-label>
                            <input matInput value="CEP" class="form-control" id="cep" name="cep" formControlName="cep"
                                maxlength="9" trim="blur" mask="00000-000" required>
                            <mat-error *ngIf="formularioFilial.controls.cep.hasError('required')">
                                O campo CEP é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioFilial.controls.cep.errors">
                                O campo CEP está inválido.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-2 col-md-6 col-sm-6 col-6">
                            <mat-label>Fone</mat-label>
                            <input type="text" matInput value="Fone" class="form-control" id="fone" name="fone"
                                phoneMask [maskInputId]="'fone'" [preValue]="formularioFilial.value.fone"
                                [phoneControl]="formularioFilial.controls['fone']" formControlName="fone" minlength="14"
                                maxlength="16" required>
                            <mat-error *ngIf="formularioFilial.controls.fone.hasError('required')">
                                O campo Fone é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioFilial.controls.fone.errors">
                                O campo Fone está inválido.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10" *ngIf="!isInfo">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioFilial.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <botao-voltar></botao-voltar>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>